// Google Workspace コネクター API クライアント。
// OAuth 開始 / 接続状態取得 / 接続テスト / 切断 の 4 エンドポイントを薄くラップする。
// ApiClient(frontend/src/api/client.ts) に乗せることで、Authorization ヘッダ付与・
// 401/403/5xx 正規化は既存クライアントに委譲する。テスト時は apiClient をスタブに差し替える。
import type { ApiClient } from "../api/client";

export interface ConnectApiDeps {
  readonly apiClient: ApiClient;
}

export interface StartResult {
  readonly authorizeUrl: string;
}

// バックエンド runGwView の status と一致させる（"disconnected" が未接続）。
// domain / customerId は Google Workspace 組織識別。
// connectedAt / lastTestAt はバックエンドが Date.now() で書く epoch MS（秒ではない）。
export interface GwConnectionStatus {
  readonly status: "connected" | "expired" | "disconnected";
  readonly domain?: string;
  readonly customerId?: string;
  readonly connectedAt?: number;
  readonly lastTestAt?: number;
}

export interface TestResult {
  readonly status: string;
}

// POST /gw/connect/start → { authorizeUrl }
export async function start(deps: ConnectApiDeps): Promise<StartResult> {
  return deps.apiClient.post<StartResult>("/gw/connect/start", {});
}

// GET /gw/connection → GwConnectionStatus
export async function getConnection(deps: ConnectApiDeps): Promise<GwConnectionStatus> {
  return deps.apiClient.get<GwConnectionStatus>("/gw/connection");
}

// POST /gw/connect/test → { status }
export async function test(deps: ConnectApiDeps): Promise<TestResult> {
  return deps.apiClient.post<TestResult>("/gw/connect/test", {});
}

// DELETE /gw/connection → 204 No Content
export async function disconnect(deps: ConnectApiDeps): Promise<void> {
  return deps.apiClient.del<void>("/gw/connection");
}
